import React from 'react';
import { FILTER_COLOR_BOXES } from '@/app/constants/filtercolors';

interface ColorBoxProps {
  color: string;
  isMobile?: boolean;
  pdpColors?: boolean;
}

const ColorBox = ({ color, isMobile = false, pdpColors = false }: ColorBoxProps) => {
  let boxImage;
  if (color === 'multi-colored' || color === 'multi') {
    boxImage = FILTER_COLOR_BOXES['multi-colored'].hexCode;
  }
  const customSize = isMobile ? '4.5rem' : pdpColors ? '2rem' : '1.1rem';
  let border = pdpColors ? '' : 'border-dark';
  if (color === 'black' || (isMobile && color !== 'white')) border = 'border-white';

  return (
    <div
      className={`position-relative border border-1 ${border} align-self-center`}
      style={{
        backgroundColor: FILTER_COLOR_BOXES[color]?.hexCode,
        backgroundImage: boxImage,
        width: customSize,
        height: customSize,
      }}></div>
  );
};

export default ColorBox;
